// Central configuration for Per Asciano
// Replace WHATSAPP_LINK and DONATE_LINK with real URLs when available.

// "Bacheca" — gruppo WhatsApp principale dell'associazione (uso secondario)
export const WHATSAPP_LINK = "https://chat.whatsapp.com/IXqhxMIrOWP6xYiReWjClZ";
export const BACHECA_LINK = "https://chat.whatsapp.com/IXqhxMIrOWP6xYiReWjClZ";
export const WHATSAPP_EVENT_LINK =
  "https://chat.whatsapp.com/ItbBQhR9vgE6dcQRA4zydz?mode=gi_t";
// Direct WhatsApp to the organizer (Italian +39)
export const WHATSAPP_DIRECT_PHONE = "393756543336";
export const WHATSAPP_DIRECT_BASE = `https://wa.me/${WHATSAPP_DIRECT_PHONE}`;
export const DONATE_LINK = "https://gofundme.com/ascianorinascita";

// FAI — I Luoghi del Cuore: Monte Faeta
export const FAI_MONTE_FAETA_LINK =
  "https://fondoambiente.it/luoghi/monte-faeta?ldc=";

// Anchor della sezione volontari (CTA primaria del sito)
export const VOLUNTEER_ANCHOR = "#volontari";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1651234970249-8a7299de4b5c?auto=format&fit=crop&w=1920&q=75",
  rebirth:
    "https://images.unsplash.com/photo-1776319223152-b1c8ca7a4702?auto=format&fit=crop&w=1600&q=75",
  volunteers:
    "https://images.unsplash.com/photo-1758599668360-48ba8ba71b47?auto=format&fit=crop&w=1400&q=75",
  tuscany:
    "https://images.unsplash.com/photo-1523365154888-8a758819b722?auto=format&fit=crop&w=1600&q=80",
  handsEarth:
    "https://images.unsplash.com/photo-1542601906990-b4d3fb778b09?auto=format&fit=crop&w=1400&q=80",
  forestGreen:
    "https://images.unsplash.com/photo-1448375240586-882707db888b?auto=format&fit=crop&w=1600&q=80",
};
